/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const OpenIdSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" viewBox="0 0 24 24" id="openid">
    <path fill="#B2B2B2" d="M10.9 20.74V23C4.74 22.46 0 19.22 0 15.29c0-3.78 4.42-6.93 10.27-7.63v2.27c-3.83.66-6.64 2.81-6.64 5.36 0 2.7 3.13 4.93 7.27 5.45zM24 13.851v-.001l-.493-5.156-1.875 1.047c-1.746-1.047-3.969-1.787-6.444-2.078v2.274c1.419.254 2.705.704 3.75 1.312l-1.972 1.094L24 13.851z"></path>
    <path fill="#F7931F" d="M14.54 1v20.31L10.9 23V2.76zM14.54 13.21h.01v8.1h-.01z"></path>
  </svg>
);

export const OpenIdIcon = (props) => (
  <Icon component={OpenIdSvg} {...props} />
);
